import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SolrEntityService, EntityTreeService, EntityPageService} from "@signature-it/ngx-entity/services";
import {ActivatedRoute, Router} from "@angular/router";
import {ShareDataService, LanguageService, EventBusService} from "@signature-it/ngx-generic/services";
import {EventData, EventName} from "@signature-it/ngx-generic/classes";
import {TreeLinks} from "@signature-it/ngx-entity/models";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
declare let _;

@Component({
    selector: 'taxonomy-sidenav',
    templateUrl: './taxonomy-sidenav.component.html',
    styleUrls: ['./taxonomy-sidenav.component.scss'],
    standalone: false
})
export class TaxonomySidenavComponent implements OnInit, OnDestroy{
    @Input() taxonomyTypeVar: string;
    @Input() nodeVar: string;
    @Input() depth: string = "10";
    @Input() key: number;
    @Input() url: string;
    tree: TreeLinks;
    activeNode;
    private destroy$: Subject<void> = new Subject<void>();

    constructor(protected solrEntityService: SolrEntityService,
                protected entityService: EntityTreeService,
                protected activatedRoute: ActivatedRoute,
                public router:Router,
                public shareDataService: ShareDataService,
                private langSvc: LanguageService,
                protected entityPageService: EntityPageService,
                protected eventBusService: EventBusService) {}

    ngOnInit() {
        this.entityPageService.updateMainEntity.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.setMainActive();
        });
        this.eventBusService.on(EventName.ENTITY_PAGE_QUERY_PARAMS_CHANGE, () => {
            this.setMainActive();
        });
        this.entityService.getTaxonomyMenu(this.taxonomyTypeVar, this.nodeVar).pipe(takeUntil(this.destroy$)).subscribe(
            res => {
                this.langSvc
                    .getCurrentLanguage$()
                    .subscribe(lang => {
                        this.tree = new TreeLinks( res, this.langSvc.isRTL( lang ), this.url);
                        this.tree.init();
                        this.setMainActive();
                    });

            },
            error => {

            }
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setMainActive () {
        this.setActiveUrl();
        this.entityPageService.selectedNode = this.activeNode;
        this.entityPageService.navIndexTree = this.tree;
        if(this.depth && this.activeNode) {
            let nodeDepth = this.calcDepth(this.activeNode, 1);
            this.activeNode = this.findActiveNodeByDepth(this.activeNode, (nodeDepth - Number(this.depth)))
        }
    }

    calcDepth(node, level) {
        return node.parent ? this.calcDepth(node.parent, level + 1) : level;
    }

    findActiveNodeByDepth(node, parentLevel) {
        return parentLevel > 0 ? this.findActiveNodeByDepth(node.parent, parentLevel - 1) : node;
    }

    nodeClick(node,$event){
        this.eventBusService.emit(new EventData(`${EventName.TAXONOMY_NODE_CLICK}`, {'key': this.key, 'nodeId':node.data.id}));
        node.handleClick($event);
    }


    setActiveUrl() {
        this.activeNode = null;
        if(this.tree) {
            if(this.url) {
                if(this.activeNode = this.tree.setActiveByProperty('uri',  this.router.url.split('?')[0].split('/').pop())) return;
            } else  {
                if(this.activeNode = this.tree.setActiveByProperty('url', this.router.url)) return;
                let url = this.router.url.split('?')[0];
                if(this.activeNode = this.tree.setActiveByProperty('url', url )) return;
                if(this.activeNode = this.tree.setActiveByProperty('url',  this.router.url.split('?')[0])) return;
                while(url) {
                    let urlArray = url.split('/');
                    urlArray.pop()
                    url = urlArray.join('/');
                    if(this.activeNode = this.tree.setActiveByProperty('url', url)) return;
                }
            }
            this.activeNode = this.activatedRoute.snapshot.queryParams['nav_node'];
            if(this.activeNode) {
                this.tree.setActiveByProperty('uri', this.activeNode);
            }

        }
    }


    isExternalLink(link) {
        return /^https?:\/\//i.test(link);
    }

}
